import MuiListItemButton, { ListItemButtonProps as MuiListItemButtonProps } from '@mui/material/ListItemButton';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const ListItemButtonStyled = styled((props: MuiListItemButtonProps & { to?: string }) => {
  return (
    <MuiListItemButton component={RouterLink} {...props} />
  );
})(() => `
  padding-left: 50px;
  margin-left: 10px;
  margin-top: 5px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;

  &:hover {
    background-color: #2B8293;
  }

  &.Mui-selected {
    background-color: #2B8293;
  }
`);